<template>
    <div id="projectDetail" :style="'background:url('+projectBg+')'">
        <div class="contentBox">
            <div class="detailCard">
                <div class="title">
                    <h2>{{ title }}</h2>
                </div>
                <div class="info">
                    发布日期:{{ info }}
                </div>
                <div class="content" v-html="content">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//静态资源导入
import projectBg from '@/assets/img/projectBg.jpg'

export default {
  data() {
    return {
        projectBg:projectBg,
        title:'',
        content:'',
        info:'',
    }
  },
  watch: {
  },
  methods: {
    async getBaseInfo(){
        let baseInfo = await this.$root.getProjectDetail(this.$route.query.id);
        this.title = baseInfo.data.title;
        this.content = baseInfo.data.content;
        let timestamp = baseInfo.data.updatetime;
        //时间戳转yyymmdd
        this.info = this.formatDate(timestamp);   
        this.$root.loadingClose(); 
    },
    formatDate(timestamp) {
        const date = new Date(timestamp * 1000); // 转换为JavaScript的时间格式
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补充0
        const day = String(date.getDate()).padStart(2, '0'); // 补充0
        
        return `${year}-${month}-${day}`;
    },
    fixContent(){
        //轮询10次 修复图片宽度
        let count = 0;
        let listen = setInterval(() => {
            let content = document.getElementsByClassName('content')[0];
            if(!content){
                clearInterval(listen);
            }
            try{
                let imgs = content.getElementsByTagName('img');
                for(let i=0;i<imgs.length;i++){
                    imgs[i].style.width = "100%";
                    imgs[i].style.height = "auto";
                }
                count++;
                if(count > 10){
                    clearInterval(listen);
                }
            }
            catch{
                console.log("warnning :not fond imgs")
            }                
        }, 500);            
    },
  },
  created() {
    this.getBaseInfo();
  },
  mounted() {
    this.$nextTick(function () {
      this.fixContent();
    });
  }
}
</script>

<style lang="scss" scoped src="@/assets/css/projectDetail.scss"></style>